module.exports = {
  notIssued: 'Не выдано',
  getBack: 'Получено обратно',
  receive: 'Получено',
  toClaim: 'Заявлено',
  issuance: 'Выдано',
  changeSingle: 'В процессе изменения',
  lineCreditDialog: {
    title: 'Информационное сообщение',
    businessNumber: 'Номер операции:',
    mblNo: 'MBL №:',
    hblNo: 'HBL №:',
    partners: 'Партнер:',
    lines: 'Кредитный лимит: превышен на {0} юаней',
    paymentDays: 'Кредитный период: {0}',
    unableSave: 'Невозможно использовать "самостоятельное оформление клиентом", пожалуйста, своевременно оплатите.',
    cantUse: 'В настоящее время невозможно сохранить отмеченные поля для самостоятельного оформления клиентом.',
    triggerRemind: 'Активировано системное напоминание, пожалуйста, своевременно оплатите.',
    through: 'Правила выпуска документов утверждены',
    continueOrders: 'Подтвердите продолжение выпуска документов?',
    confirm: 'Подтвердить',
    cancel: 'Закрыть'
  }
}
